/**
 * Production 배포 환경 여부.
 */
export const isDeploy = import.meta.env.PROD && import.meta.env.MODE === 'production';
